import { ActionIcon, Box, Button, Grid, Group, Loader, Modal, Paper, Text, Title, UnstyledButton } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import React, { useEffect, useState } from "react";
import { FaPhone, FaPlus, FaWhatsapp } from "react-icons/fa";
import QRCode from "react-qr-code";
import { useApp } from "../contexts/app.context";
import { useAuth } from "../contexts/auth.context";
import { GET_ALL_WHATSAPPS, GET_WHATSAPP_QR_CODE, SAVE_WHATSAPP } from "../services/phones";

export default function Whatsapps() {
    const [data, setData] = useState<any[]>([]);
    const [loadingSave, setLoadingSave] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [newPhone, setNewPhone] = useState<any>(null);
    const [availableWhatsapps, setAvailableWhatsapps] = useState<any[]>([]);

    const {confirmDialog} = useApp();

    const loadWhatsapps = () => {
        setLoading(true);
        GET_ALL_WHATSAPPS()
            .then((res) => {
                setLoading(false);
                setData(res);
            })
            .catch(err => {
                setLoading(false);
                showNotification({ title: "Ops.", message: err.message, color: 'red' })
            })
    }

    const handleSave = () => {
        setLoadingSave(true)
        SAVE_WHATSAPP({})
            .then((res) => {
                setLoadingSave(false)
                loadWhatsapps()
                setNewPhone(null);
                showNotification({ message: "Siga os passos para conectar sua conta", color: 'green' })
            })
            .catch(err => {
                setLoadingSave(false)
                showNotification({ title: "Ops.", message: err.message, color: 'red' })
            })
    }

    useEffect(() => {
        loadWhatsapps()
    }, []);

    return <>
        {data.length === 0 && <UnstyledButton disabled={loadingSave || loading} style={{ width: '100%' }} onClick={() => {
            confirmDialog({
                text: "O próprio WhatsApp desconecta o número por motivos de segurança — não se preocupe, é normal! Avisaremos caso isso ocorra. Basta escanear o QR Code novamente para reconectar e seguir com seus envios normalmente",
                buttonText: "Ok, conectar"
            }, ({confirmed}) => {
                if(confirmed){
                    handleSave()
                }
            })
        }}>
            <Paper p="xl" shadow="xs" style={{ border: '1px solid #DFDFDF', borderRadius: 5, backgroundColor: '#25d366' }}>
                <Group>
                    {(loading || loadingSave) ? <Loader size={30} /> : <FaWhatsapp color="white" size={30} />}
                    <Box style={{ flex: 1 }}>
                        <Text size="xl" c="white" fw="bold">Conectar Whatsapp</Text>
                    </Box>
                </Group>
            </Paper>
        </UnstyledButton>}

        {data.map((wpp: any) => (
            <WppItem refresh={loadWhatsapps} item={wpp} />
        ))}

        <Modal
            opened={!!newPhone}
            onClose={() => setNewPhone(null)}
        >
            <Text size="md" ta="center" mb="md">Configurar seu número de whatsapp para envio de notificações</Text>

            <Group style={{ justifyContent: "flex-end" }}>
                <Button onClick={handleSave}>Configurar</Button>
            </Group>
        </Modal>
    </>
}


export const WppItem = ({ item, refresh }) => {
    const [qrCode, setQrCode] = useState<any>();
    const { socket } = useApp();

    const loadQrCode = () => {
        GET_WHATSAPP_QR_CODE(item._id)
            .then(res => {
                setQrCode(res);
            })
            .catch(err => {
            })
    }

    React.useEffect(() => {
        if (item?._id) {
            const func = (dt) => {
                console.log("refreshed", dt)
                refresh();
                loadQrCode();
            }
            socket.on(`whatsapp_updated_${item._id}`, func);
            return () => {
                socket.removeAllListeners(`whatsapp_updated_${item._id}`);
            };
        }
    }, [socket, item?._id])
    React.useEffect(() => { refresh() }, [])
    React.useEffect(() => { if (item?.data?.lastStatus?.status === "SCAN_QR_CODE") loadQrCode() }, [item?.data?.lastStatus?.status])

    return <Paper p="xl" shadow="xs" ta="center" style={{ backgroundColor: '#25d366' }} mb="xs">
        {
            (!item?.configured)
                ? <Group>
                    {qrCode?.value ? <QRCode size={200} value={qrCode.value} /> : <Loader />}

                    <Text style={{ flex: 1 }} ta="center" c="white" mb="lg" fw="bold" size="xl">Leia o qrcode com sua conta de Whatsapp para conectar.</Text>
                    {/* <img
                            style={{width: '100%'}}
                            src={`${process.env.REACT_APP_SERVER_URL}/items/whatsapps/${item?._id}/qrcode`} /> */}
                </Group>
                : <Group>
                    <FaWhatsapp color="white" size={30} />
                    <Text c="white" fw="bold" size="xl">{item?.data?.phone}</Text>
                </Group>
        }
    </Paper>
}